import {
  GET_DEPARTMENT_REQUEST,
  GET_DEPARTMENT_SUCCESS,
  GET_DEPARTMENT_FAILURE,
  GET_DEPT_INTG_REQUEST,
  GET_DEPT_INTG_SUCCESS,
  GET_DEPT_INTG_FAILURE,
  POST_DEPT_REQUEST,
  POST_DEPT_SUCCESS,
  POST_DEPT_FAILURE,
  PATCH_DEPT_REQUEST,
  PATCH_DEPT_SUCCESS,
  PATCH_DEPT_FAILURE,
  DELETE_DEPT_REQUEST,
  DELETE_DEPT_SUCCESS,
  DELETE_DEPT_FAILURE,
  PATCH_DEPT_INTG_REQUEST,
  PATCH_DEPT_INTG_SUCCESS,
  PATCH_DEPT_INTG_FAILURE,
  GET_DEPT_CSV_REQUEST,
  GET_DEPT_CSV_SUCCESS,
  GET_DEPT_CSV_FAILURE,
} from '../constants/networkadmin/Department';


const initialState = {
  requesting: false,
  message: '',
  department_list: '',
  dept_intg_list: [],
  refreshDepartment: false,
  refreshDeptIntg: false,
};

export default function department(state = initialState, action) {
  switch (action.type) {

    case GET_DEPARTMENT_REQUEST:
      return {
        ...state,
        requesting: action.payload.requesting,
        refreshDepartment: false,
        message: '',
      };

    case GET_DEPARTMENT_SUCCESS:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
        department_list: action.payload.data,
      };

    case GET_DEPARTMENT_FAILURE:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
      };

    case GET_DEPT_INTG_REQUEST:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: '',
        refreshDeptIntg: false,
        dept_intg_list: [],
      };

    case GET_DEPT_INTG_SUCCESS:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
        dept_intg_list: action.payload.data,
      };

    case GET_DEPT_INTG_FAILURE:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
      };

    case POST_DEPT_REQUEST:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: '',
        refreshDepartment: false,
      };

    case POST_DEPT_SUCCESS:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
        refreshDepartment: true,
      };

    case POST_DEPT_FAILURE:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
      };

    case PATCH_DEPT_REQUEST:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: '',
        refreshDepartment: false,
      };

    case PATCH_DEPT_SUCCESS:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
        refreshDepartment: true,
      };

    case PATCH_DEPT_FAILURE:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
      };

    case DELETE_DEPT_REQUEST:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: '',
        refreshDepartment: false,
      };

    case DELETE_DEPT_SUCCESS:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
        refreshDepartment: true,
      };

    case DELETE_DEPT_FAILURE:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
      };

    case PATCH_DEPT_INTG_REQUEST:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: '',
        refreshDeptIntg: false,
      };

    case PATCH_DEPT_INTG_SUCCESS:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
        refreshDeptIntg: true,
      };

    case PATCH_DEPT_INTG_FAILURE:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
      };

    case GET_DEPT_CSV_REQUEST:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: '',
      };

    case GET_DEPT_CSV_SUCCESS:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
        department_list_csv: action.payload.data,
      };

    case GET_DEPT_CSV_FAILURE:
      return {
        ...state,
        requesting: action.payload.requesting,
        message: action.payload.message,
      };
    default:
      return state;
  }
}
